import { render, staticRenderFns } from "./corporateBranchForm.vue?vue&type=template&id=2ebb7ad2&scoped=true&"
import script from "./corporateBranchForm.vue?vue&type=script&lang=js&"
export * from "./corporateBranchForm.vue?vue&type=script&lang=js&"
import style0 from "./corporateBranchForm.vue?vue&type=style&index=0&id=2ebb7ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb7ad2",
  null
  
)

export default component.exports